import Model from './BaseModel';

export default class SportcastLeague extends Model {
	resourceName() {
		return 'sportcast_leagues';
	}

	fields() {
		return ['league_id', 'competition_id', 'name', 'sport_id', 'sport_name', 'country'];
	}
}
